export default "__VITE_ASSET__DGmnXdwo__"